import { useMutation, useQueryClient } from "@tanstack/react-query";
import { notification } from "antd";
import { journalsQueries } from "@/entities/journal";
import { NOTIFICATION_MESSAGES } from "@/shared/utils";
import { updateSectionFourTwoRecordSigned } from "../utils/update-section-four-two-record-signed";

interface IRequest {
  mainJournalId: string;
  section4Id: string;
  section4ListId: string;
  itemNoVersionId: string;
  companyId?: string;
  itemPartOne?: string; // id only
  itemPartTwo?: {
    defectFixingFactDate?: string;
    createOtherDocs?: {
      fileMetadata: {
        fileNumber: number;
        fileName: string;
        fileType: string;
        fileContentLength: number;
        id?: string;
        fileId?: string;
      };
      file?: File | Blob;
    }[];
    deleteOtherDocs?: { file: { id: string; fileId: string } }[];
    defectFixingInspectionEmployeeId?: string;
  };
  actionDetails: string;
}

export function useUpdateSectionFourTwoEntrySigned({
  section4ListId,
  versionId,
  itemPartTwoId,
}: {
  section4ListId: string;
  versionId: string;
  itemPartTwoId: string;
}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: IRequest) =>
      updateSectionFourTwoRecordSigned({
        sectionFourListId: section4ListId,
        versionId,
        itemPartTwoId,
        updateRequest: data,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: journalsQueries.getSection4({ section4ListId }).queryKey,
      });
      notification.success({
        message: NOTIFICATION_MESSAGES.SUCCESS, // "Успешно"
        description: NOTIFICATION_MESSAGES.ENTRY_SIGNED_P2_UPDATED_DESC, // "Подписанная запись (часть 2) обновлена"
      });
    },
    onError: () => {
      notification.error({
        message: NOTIFICATION_MESSAGES.ERROR, // "Ошибка"
        description: NOTIFICATION_MESSAGES.ENTRY_SIGNED_P2_UPDATE_FAILED_DESC, // "Не удалось обновить подписанную запись (часть 2)"
      });
    },
  });
}


